export const scrollToElementWithOffset = (
  selector = "body",
  offset = 50,
  behavior = "smooth"
) => {
  const element = document.querySelector(selector);
  if (element) {
      const targetY = element.getBoundingClientRect().top + window.scrollY - offset;
      
      window.scrollTo({ top: targetY, behavior });
   
  }
};